import {useEffect, useCallback, useRef} from '@wordpress/element';
import {useProcessCheckoutError} from './hooks/use-process-checkout-error';
import {
    handleNextAction,
    isNextActionRequired,
    initStripe,
    ensureSuccessResponse,
    ensureErrorResponse
} from "@wc-stripe/blocks-utils";

const SavedCardComponent = (
    {
        billing,
        emitResponse,
        eventRegistration
    }) => {
    const {onCheckoutSuccess, onCheckoutFail} = eventRegistration;
    const {billingAddress} = billing;
    const currentData = useRef({emitResponse, billingAddress});

    useEffect(() => {
        currentData.current = {...currentData.current, emitResponse, billingAddress};
    }, [
        emitResponse,
        billingAddress
    ]);

    useProcessCheckoutError({
        emitResponse,
        subscriber: onCheckoutFail,
        messageContext: emitResponse.noticeContexts.PAYMENTS
    });

    const handleSuccessResult = useCallback(async ({redirectUrl}) => {
        const {emitResponse, billingAddress} = currentData.current;
        let args;
        if ((args = isNextActionRequired(redirectUrl))) {
            const stripe = await initStripe;
            try {
                const result = await handleNextAction({args, stripe, billingAddress});
                return ensureSuccessResponse(emitResponse.responseTypes, result);
            } catch (error) {
                return ensureErrorResponse(
                    emitResponse.responseTypes,
                    error,
                    {messageContext: emitResponse.noticeContexts.PAYMENTS}
                );
            }
        }
    }, []);

    useEffect(() => {
        const unsubscribe = onCheckoutSuccess(handleSuccessResult);
        return () => unsubscribe();
    }, [
        onCheckoutSuccess,
        handleSuccessResult
    ]);
    return null;
}

export default SavedCardComponent;
